/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_RoadmapInputs */

const en_mk_foot_roadmap = /** @type {(inputs: Mk_Foot_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roadmap`)
};

const id_mk_foot_roadmap = /** @type {(inputs: Mk_Foot_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roadmap`)
};

/**
* | output |
* | --- |
* | "Roadmap" |
*
* @param {Mk_Foot_RoadmapInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_roadmap = /** @type {((inputs?: Mk_Foot_RoadmapInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_RoadmapInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_roadmap(inputs)
	return en_mk_foot_roadmap(inputs)
});